/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerApplyMutationRequest, WorkflowApplicationsControllerApplyMutationResponse, WorkflowApplicationsControllerApply400, WorkflowApplicationsControllerApply401, WorkflowApplicationsControllerApply403 } from "../../models/workflowsController/WorkflowApplicationsControllerApply";

function getWorkflowApplicationsControllerApplyUrl() {
  const res = { method: 'POST', url: `/api/v1/workflow-applications` as const }  
  return res
}

/**
 * @summary Apply a workflow template to a file, files, or a project
 * {@link /api/v1/workflow-applications}
 */
export async function workflowApplicationsControllerApply(data?: WorkflowApplicationsControllerApplyMutationRequest, config: Partial<RequestConfig<WorkflowApplicationsControllerApplyMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowApplicationsControllerApplyMutationResponse, ResponseErrorConfig<WorkflowApplicationsControllerApply400 | WorkflowApplicationsControllerApply401 | WorkflowApplicationsControllerApply403>, WorkflowApplicationsControllerApplyMutationRequest>({ method : "POST", url : getWorkflowApplicationsControllerApplyUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}